export const optionRl = {
    title: {
        text: `0      3       6      9     12    15`,
        textStyle: {
            color: '#999',
            fontSize: 12
        },
        top: 27,
        right: -5
    },
    visualMap: {
        type: 'piecewise',
        pieces: [{
            min: 12,
            // max: 15,
            color: '#D39D1A',
            symbol: 'rect'
        },
        {
            min: 9,
            max: 12,
            color: '#DAAC3B',
            symbol: 'rect'
        },
        {
            min: 6,
            max: 9,
            color: '#E4BF68',
            symbol: 'rect'
        },
        {
            min: 3,
            max: 6,
            color: '#EBCD86',
            symbol: 'rect'
        },
        {
            min: 0,
            max: 3,
            color: '#F3DFAF',
            symbol: 'rect'
        }
        ],
        orient: 'horizontal',
        itemWidth: 30,
        itemHeight: 20,
        align: 'top',
        itemGap: 0,
        showLabel: false,
        itemSymbol: 'rect',
        seriesIndex: [0],
        textStyle: {
            color: '#7B93A7'
        },
        top: 0,
        right: 0,
    },
    tooltip: {
        show: true
    },
    grid: {
        top: 100,
        left: 120,
        right: 55,
        bottom: 75
    },
    xAxis: [
        {
            type: "category",
            gridIndex: 0,
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                textStyle: {
                    color: '#333',  //更改坐标轴文字颜色
                    fontSize: 12      //更改坐标轴文字大小
                },
                rotate: -45
                // interval: 0
            },
            splitLine: {
                show: false
            },
            data: []
            // data: [0, 1, 2, 3, 4]
        }
    ],
    yAxis: [
        {
            type: "category",
            gridIndex: 0,
            splitNumber: 1,
            name: "lncRNA ID",
            nameLocation: "middle",
            nameGap: 20,
            nameRotate: 0,
            nameTextStyle: {
                fontWeight: "bold",
                fontSize: 16
            },
            axisLabel: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLine: {
                show: false
            }
        }
    ],
    series: [
        {
            type: "heatmap",
            label: {
                show: false,
                formatter: function (params) {
                    return parseInt(params.value[2]);
                }
            },
            "'xAxisIndex'": "0",
            "'yAxisIndex'": "0",
            data: [
                // [0, 0, 100],
                // [1, 0, 300],
                // [2, 0, 500],
                // [3, 0, 700],
                // [4, 0, 900]
            ]
        }
    ]
}
let categories = [];
for (let i = 0; i < 2; i++) {
    categories[i] = {
        name: "Gene" + i
    };
}
export const optionGx = {
    color: ['#2F4555', '#62A1A9', '#91C7Af', '#EBCD86'],
    tooltip: {
        trigger: 'item',
        formatter(params) {
            if (params.data) {
                return params.data.label === undefined ? '' : 'Other name：' + params.data.label;
            }
        }
    },
    legend: [
        {
            selectedMode: false, // 取消点击事件
            show: false,
            // left: 0,
            icon: "circle",
            type: 'scroll',
            orient: 'vertical',
            left: 10,
            top: 62,
            // data: categories.map(function (a) {
            //     return a.name;
            // }),
            data: ['validate lncRNA', 'lncRNA_id', 'gene_id', 'isoform_id']
        }
    ],
    series: [
        {
            name: "",
            type: "graph",
            layout: "force",
            categories: [],
            animation: false,
            data: [
                {
                    name: "Gene11",
                    category: 'Gene1',
                    symbolSize: 20
                },
                {
                    name: "Gene12",
                    category: 'Gene1',
                    symbolSize: 50
                },
                {
                    name: "Gene13",
                    category: 'Gene1',
                    symbolSize: 20
                },
                {
                    name: "Gene22",
                    category: 'Gene2',
                    symbolSize: 30
                },
                {
                    name: "Gene21",
                    category: 'Gene2',
                    symbolSize: 30
                },
                {
                    name: "Gene02",
                    category: 'Gene0',
                    symbolSize: 20
                },
                {
                    name: "Gene01",
                    category: 'Gene0',
                    symbolSize: 20
                }
            ],
            links: [
                {
                    source: "Gene11",
                    target: "Gene12",
                    lineStyle: {
                        color: '#f00'
                    }
                },
                {
                    source: "Gene12",
                    target: "Gene13",
                    lineStyle: {
                        color: '#f00'
                    }
                },
                {
                    source: "Gene21",
                    target: "Gene22"
                },
                {
                    source: "Gene01",
                    target: "Gene02"
                },
                {
                    source: "Gene21",
                    target: "Gene12",
                    lineStyle: {
                        color: '#f00'
                    }
                },
                {
                    source: "Gene11",
                    target: "Gene01"
                }
            ],
            categories: categories,
            roam: true,
            label: {
                position: "right"
            },
            force: {
                repulsion: 200,
                edgeLength: 100
            }
        }
    ]
}
export const footerItem = [
    {
        label: 'Methods',
        value: ''
    },
    {
        label: 'Sample',
        value: ''
    },
    {
        label: 'Expression pattern',
        value: ''
    },
    {
        label: 'Dysfunction type',
        value: ''
    }
]
export const tableDataItem = [
    {
        prop: "pmid",
        label: "PMID",
        width: 130
    },
    {
        prop: "sra_study",
        label: "SRA Study",
        width: 130
    },
    {
        prop: "run_id",
        label: "SRA Run",
        width: 130
    },
    {
        prop: "treatment",
        label: "Treatment"
    },
    {
        prop: "dev_stage",
        label: "Development Stage"
    },
    {
        prop: "tissue",
        label: "Tissue",
        width: 130
    },
    {
        prop: "value",
        label: "TPM",
        width: 130
    }
]

export const optionBar = {
    color: ['#D39D1A'],
    grid: {
        top: 10,
        left: 50,
        right: 50,
        bottom: 60
    },
    tooltip: {
        trigger: 'axis',
        formatter(params) {
            let res
            res = `<div><span>SRA Run：</span>${params[0].axisValue}</div>` +
                '<div><span>Development Stage：</span>' + params[0].data.name + '</div>' +
                '<div><span>Tissue：</span>' + params[0].data.tissue + '</div>' +
                `<div><span>TPM：</span>${params[0].data.value}</div>`
            return res
        }
    },
    xAxis: {
        type: 'category',
        axisLabel: {
            textStyle: {
                color: '#333',  //更改坐标轴文字颜色
                fontSize: 12      //更改坐标轴文字大小
            },
            rotate: -45
            // interval: 0
        },
        data: []
    },
    yAxis: {
        type: 'value'
    },
    series: [{
        data: [],
        barMaxWidth: 30,
        type: 'bar'
    }]
}
